import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export const saveReactToPdf = async (
  refElement,
  { fileName = `download.pdf`, scale = 1, x = 10, y = 10 }
) => {
  const source = refElement;
  const targetComponent = source.current || source;
  if (!targetComponent) {
    throw new Error('Target ref is required');
  }

  const canvas = await html2canvas(targetComponent, {
    logging: false,
    useCORS: true,
    scale,
  });

  const imgData = canvas.toDataURL();
  const pdf = new jsPDF({
    format: 'a4',
  });
  pdf.addImage(imgData, 'JPEG', x, y);
  pdf.save(fileName);
};
